<template>
    <div class="FlowCard Box BoxMedium" v-if="cardData">
        <span class="Name">({{cardName}})</span><br />
        <span class="Title" v-html="title"></span>
    </div>
    <div class="FlowCard Box BoxMedium RegularMarginBottom" v-else>
        <span class="Title">{{title}}</span>
    </div>
</template>

<script>
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { Getter, Action, Mutation } from 'vuex-class';

    @Component({
        components: {}
    })
    export default class FlowCard extends Vue {
        @Getter('api/homey/flow/card/triggers') triggers;
        @Action('api/homey/flow/card/retrieveTriggers') retreiveTriggerCards;
        @Getter('api/homey/flow/card/conditions') conditions;
        @Action('api/homey/flow/card/retrieveConditions') retreiveConditionCards;
        @Getter('api/homey/flow/card/actions') actions;
        @Action('api/homey/flow/card/retrieveActions') retreiveActionCards;
        @Prop({ type: Object }) card;
        @Prop({ type: String }) type;

        created() {
            if (!this.cards) {
                this.retreiveCards();
            }
        }

        retreiveCards() {
            switch(this.type) {
                case 'trigger':
                return this.retreiveTriggerCards();
                case 'condition':
                return this.retreiveConditionCards();
                case 'action':
                return this.retreiveActionCards();
            }
        }

        get cards() {
            switch(this.type) {
                case 'trigger':
                return this.triggers;
                case 'condition':
                return this.conditions;
                case 'action':
                return this.actions;
            }
        }

        get cardData() {
            if (!this.cards) {
                this.retreiveCards();
                return null;
            }

            return this.cards.find(card => card.uri === this.card.uri && card.id === this.card.id);
        }

        get title(){
            const cardData = this.cardData;
            if(!cardData) return "This card is broken";
            let title = cardData.title;
            title = title.replace(/!{{([^|}]*)\|([^|}]*)}}/g, this.card.inverted ? '$2' : '$1')

            if( cardData.droptoken ) {
	            title = `<span class="Arg">${this.card.droptoken}</span> ` + title;
            }

            if( cardData.args ) {
	            if( cardData.args.length )
	            	title += '<br />';

	            cardData.args.forEach(arg => {
		            let value = this.card.args[arg.name];
		            title += ` <span class="Arg">${value.name || value.title || value}</span>`;
	            })
            }

            return title;
        }

        get cardName() {
	        return this.cardData.uriObj.name;
        }

    }
</script>

<style lang="scss">
.FlowCard {
	margin-bottom: 2vw;

    word-wrap: break-word;
    word-break: break-all;
}
.FlowCard .Arg {
	color: #AA0000;
}
.FlowCard .Arg:before {
	content: '[';
	color: #666;
}
.FlowCard .Arg:after {
	content: ']';
	color: #666;
}
.FlowCard .Name {
	color: #FDFD67;
}
</style>
